import Grid from '@mui/material/Grid2';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';

function TransformersSection() {
  return (
    <section className="bg-[#F8FAFC]">
      <div className="max-w-[1200px] mx-auto py-96 px-40">
        <Grid container spacing={6} alignItems="center">

          <Grid size={{ xs: 12, md: 7 }}>
            <div className="inline-flex items-center gap-8 bg-[#EFF6FF] text-[#1A56DB] font-bold text-14 tracking-[0.06em] uppercase py-6 px-16 rounded-full mb-24">
              <PrecisionManufacturingIcon className="!text-18" />
              Transformadores
            </div>

            <h2 className="text-40 font-extrabold text-[#1E3A8A] leading-[1.2] mb-24">
              Respalda tu proceso productivo con trazabilidad
            </h2>

            <p className="text-20 text-[#475569] leading-[1.75] max-w-[600px]">
              Certifica la transformación del material y genera información confiable para toda la cadena.
            </p>
          </Grid>

          <Grid size={{ xs: 12, md: 5 }}>
            <div className="bg-[linear-gradient(135deg,#1E3A8A_0%,#1A56DB_100%)] rounded-20 h-full min-h-[340px] flex flex-col items-center justify-center py-48 px-32 text-center">
              <PrecisionManufacturingIcon className="!text-60 text-white/20 mb-24" />
              <p className="text-18 text-white/80 leading-[1.6]">
                Cada transformación registrada y respaldada con información verificable para toda la cadena.
              </p>
            </div>
          </Grid>

        </Grid>
      </div>
    </section>
  );
}

export default TransformersSection;
